import React, { FC } from 'react';
import styles from './ActionButton.module.scss';
import IActionButton from './IActionButton';
import classNames from 'classnames';

const ActionButton: FC<IActionButton> = ({
	type,
	className,
	onClick,
	tooltipId,
	tooltipContent,
}) => {
	return (
		<span
			{...(tooltipId ? { 'data-tooltip-id': tooltipId } : {})}
			{...(tooltipContent ? { 'data-tooltip-content': tooltipContent } : {})}
			className={classNames(styles['action-button'], styles[type], className)}
			onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
				e.stopPropagation();
				if (onClick) onClick();
			}}
		></span>
	);
};

export default React.memo(ActionButton);
